import React from "react";
import { Box, Grid2 } from "@mui/material";
import Seat from "../seat";

function Content() {
  return (
    <Box>
      <Grid2 container spacing={2}>
        {new Array(20).fill(0).map((_, index) => {
          return (
            <Grid2 key={index} size={{ xs: 12, sm: 4, md: 2 }}>
              <Seat data={{ name: index + 1 }} />
            </Grid2>
          );
        })}
      </Grid2>
    </Box>
  );
}

export default Content;
